'use client'

import { usePasswordSettings } from '@repo/services'
import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Card, Col, Typography } from '@repo/ui/components'
import Image from 'next/image'

export const PasswordContainer = () => {
  const { t } = useTranslate()

  const { data: passwordSettingsData } = usePasswordSettings()

  const isSetPassword = passwordSettingsData?.data?.srpHash

  return (
    <Card className='!gap-3xl' withoutBorder>
      <Typography size='md' weight='bold'>
        {t('profileLayout_password')}
      </Typography>
      <Col className='items-center gap-xs p-md'>
        <Image src='/images/key.webp' alt='key' width={64} height={64} />
        <Typography size='sm' color='text-base-surface-100'>
          {t(
            isSetPassword
              ? 'profileLayout_password_description_change'
              : 'profileLayout_password_description_set',
          )}
        </Typography>
        <ButtonLink
          href={`/auth/${isSetPassword ? 'change' : 'set'}-password`}
          variant='fill'
          size='sm'
          buttonClassName='px-lg'
        >
          {t(
            isSetPassword
              ? 'profileLayout_password_button_set'
              : 'profileLayout_password_button',
          )}
        </ButtonLink>
      </Col>
    </Card>
  )
}
